import { JoonUIColor } from "@joonapp/web-shared"

import ClientListTabs from "./ClientListTabs"
import useClientListTabStore, {
  ClientListTab,
} from "./hooks/useClientListTabStore"
import useMobileViewStore, { SendBirdView } from "./store/useMobileViewStore"
import ChannelHeader from "../../components/channelHeader/ChannelListHeader"
import TodoUserList from "../../components/todos/TodoUserList"
import useMobile from "../../hooks/useMobile"
import ClientList from "../clients/ClientList"

const ChannelPanel = () => {
  const isMobile = useMobile()
  const { view } = useMobileViewStore()
  const { tab } = useClientListTabStore()

  if (isMobile && view !== SendBirdView.CHANNEL_LIST) return null

  return (
    <div
      className="flex flex-col flex-1"
      style={{
        width: isMobile ? "100vw" : "min(30vw, 400px)",
        minWidth: isMobile ? "100vw" : "min(30vw, 400px)",
        maxWidth: isMobile ? "100vw" : "min(30vw, 400px)",
        background: JoonUIColor.background.primaryNeutral,
        borderRight: `1px solid ${JoonUIColor.border.default}`,
      }}
    >
      <ChannelHeader />
      <ClientListTabs />
      <div className="flex-col flex-grow flex-1 overflow-y-auto w-full">
        {tab === ClientListTab.CLIENTS && <ClientList />}
        {tab === ClientListTab.TODOS && <TodoUserList />}
      </div>
    </div>
  )
}

export default ChannelPanel
